(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ff-audit-bundles"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (root.dataset.ffReady) return;
    root.dataset.ffReady = 'true';
    const nav = root.querySelector('.ff-clear__jump');
    const tabs = Array.from(root.querySelectorAll('[data-ff-tab]'));
    const panels = Array.from(root.querySelectorAll('[data-ff-panel]'));
    const media = window.matchMedia('(max-width: 699px)');
    let active = Math.max(0, panels.findIndex(panel => '#' + panel.id === window.location.hash));
    const select = (index, focus) => {
      active = index;
      tabs.forEach((tab, i) => {
        if (media.matches) {
          tab.setAttribute('aria-selected', String(i === active));
          tab.tabIndex = i === active ? 0 : -1;
        }
      });
      panels.forEach((panel, i) => { panel.hidden = media.matches && i !== active; });
      if (focus) tabs[active].focus();
    };
    const setup = () => {
      if (media.matches) nav.setAttribute('role', 'tablist');
      else nav.removeAttribute('role');
      tabs.forEach((tab, i) => {
        tab.id = 'ff-tab-' + root.querySelector('h1').id + '-' + i;
        if (media.matches) {
          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-controls', panels[i].id);
          panels[i].setAttribute('role', 'tabpanel');
          panels[i].setAttribute('aria-labelledby', tab.id);
        } else {
          tab.removeAttribute('role'); tab.removeAttribute('aria-controls'); tab.removeAttribute('aria-selected'); tab.removeAttribute('tabindex');
          panels[i].removeAttribute('role');
          panels[i].setAttribute('aria-labelledby', panels[i].querySelector('h2').id);
        }
      });
      root.querySelectorAll('.ff-clear__details').forEach(details => { details.open = !media.matches; });
      select(active, false);
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', event => {
        if (!media.matches) return;
        event.preventDefault(); select(index, false);
      });
      tab.addEventListener('keydown', event => {
        if (!media.matches) return;
        let next = active;
        if (event.key === 'ArrowRight') next = (active + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (active - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault(); select(next, true);
      });
    });
    media.addEventListener('change', setup);
    root.addEventListener('shopify:block:select', event => {
      const index = panels.indexOf(event.target.closest('[data-ff-panel]'));
      if (index >= 0) select(index, false);
    });
    setup();
  };
  const initAll = () => document.querySelectorAll('[data-ff-bundles]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-case-builder"] && !Shopify.designMode) return;
  try {
    
// Selection, presentation and basket submission stay separate so the builder
// can grow without assumptions about how many trays make a case.
if (!customElements.get('ff-case-builder')) {
  customElements.define('ff-case-builder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.quantities = new Map();
      this.busy = false;
      this.locked = false;
      this.cards = [...this.querySelectorAll('[data-card]')];
      this.variants = new Map();
      this.text = JSON.parse(this.querySelector('[data-translations]').textContent);
      this.money = new Intl.NumberFormat(this.dataset.locale || 'en-GB', {style:'currency', currency:this.dataset.currency || 'GBP'});
      for (const card of this.cards) {
        for (const option of card.querySelectorAll('option')) this.variants.set(option.value, {card, option});
      }
      this.addEventListener('click', event => this.handleClick(event));
      this.addEventListener('change', event => {if (event.target.matches('[data-format]')) this.render();});
      this.restore();
      this.render();
    }
    t(key, values = {}) {
      let str = this.text[key] || key;
      for (const [name,value] of Object.entries(values)) str = str.replaceAll('__'+name+'__', String(value));
      return str;
    }
    format(value) { return this.money.format(value / 100); }
    trayLabel(count) { return this.t(count === 1 ? 'one_tray' : 'tray_quantity', {count}); }
    item(id) {
      const entry = this.variants.get(String(id));
      if (!entry) return null;
      const {card, option} = entry;
      const pack = option.dataset.pack;
      const match = pack.match(/(\d+)\s+(cans?|bottles?)/i);
      const stock = option.dataset.max;
      return {id:option.value, title:card.dataset.title, url:card.dataset.url, image:option.dataset.image, pack, price:Number(option.dataset.price), available:option.dataset.available === 'true', max:stock === '' || stock === undefined ? Infinity : Number(stock), units:match ? Number(match[1]) : 0, unit:match && /^bottle/i.test(match[2]) ? 'bottles' : 'cans'};
    }
    selection() {
      const items = [...this.quantities].map(([id,quantity]) => ({...this.item(id), quantity}));
      return {items, count:items.reduce((n,item) => n+item.quantity,0), total:items.reduce((n,item) => n+item.price*item.quantity,0)};
    }
    setQuantity(id, quantity) {
      const item = this.item(id);
      if (!item || !Number.isSafeInteger(quantity) || quantity < 0) return false;
      if (quantity > 0 && (!item.available || quantity > item.max)) {this.say(this.t('stock_limit'));return false;}
      if (quantity) this.quantities.set(String(id),quantity);
      else this.quantities.delete(String(id));
      return true;
    }
    say(message) { this.querySelector('[data-status]').textContent = message; }
    handleClick(event) {
      const button = event.target.closest('button');
      if (!button || !this.contains(button) || this.busy || this.locked) return;
      if (button.hasAttribute('data-filter')) {
        const filter = button.dataset.filter;
        for (const b of this.querySelectorAll('[data-filter]')) b.setAttribute('aria-pressed', String(b === button));
        for (const card of this.cards) card.hidden = filter !== 'all' && card.dataset.category !== filter;
        this.renderCount();
        return;
      }
      if (button.hasAttribute('data-submit')) {this.submit();return;}
      if (button.hasAttribute('data-clear')) this.quantities.clear();
      else {
        const card = button.closest('[data-card]');
        const id = button.dataset.variant || card?.querySelector('select').value;
        if (!id) return;
        let quantity = this.quantities.get(id) || 0;
        if (button.hasAttribute('data-remove')) quantity = 0;
        else if (button.hasAttribute('data-decrease')) quantity--;
        else if (button.hasAttribute('data-add') || button.hasAttribute('data-increase')) quantity++;
        else return;
        if (!this.setQuantity(id,quantity)) return;
      }
      this.say('');
      this.save();
      this.render();
    }
    renderCount() {
      this.querySelector('[data-result-count]').textContent = this.t('drink_count',{count:this.cards.filter(card => !card.hidden).length});
    }
    renderCards() {
      const disabled = this.busy || this.locked;
      for (const card of this.cards) {
        const item = this.item(card.querySelector('select').value);
        if (!item) continue;
        const quantity = this.quantities.get(item.id) || 0;
        const selected = [...card.querySelectorAll('option')].some(option => this.quantities.has(option.value));
        card.classList.toggle('is-selected',selected);
        card.querySelector('[data-selected]').hidden = !selected;
        card.querySelector('[data-price-display]').textContent = this.format(item.price);
        card.querySelector('[data-pack-label]').textContent = item.pack;
        card.querySelector('[data-unit]').textContent = item.units ? this.t('per_unit',{price:this.format(Math.round(item.price/item.units)),unit:this.t(item.unit === 'cans' ? 'can' : 'bottle')}) : '';
        const image = card.querySelector('img');
        if (image && image.getAttribute('src') !== item.image) {image.src=item.image;image.removeAttribute('srcset');}
        const product = item.title+' — '+item.pack;
        const add = card.querySelector('[data-add]');
        add.hidden = quantity > 0;
        add.disabled = !item.available || disabled;
        add.firstChild.textContent = this.t(item.available ? 'add' : 'sold_out')+' ';
        add.setAttribute('aria-label',this.t('add_one',{product}));
        card.querySelector('[data-counter]').hidden = quantity === 0;
        card.querySelector('[data-quantity]').textContent = this.trayLabel(quantity);
        const increase = card.querySelector('[data-increase]');
        increase.disabled = !item.available || quantity >= item.max || disabled;
        increase.setAttribute('aria-label',this.t('add_one',{product}));
        const decrease = card.querySelector('[data-decrease]');
        decrease.disabled = disabled;
        decrease.setAttribute('aria-label',this.t('remove_one',{product}));
        card.querySelector('select').disabled = disabled;
      }
    }
    renderSummary(items) {
      const slots = this.querySelector('[data-slots]');
      const active = document.activeElement;
      const focused = slots.contains(active) ? {id:active.dataset.variant,action:active.dataset.action} : null;
      slots.replaceChildren();
      if (!items.length) {
        const empty = document.createElement('li');empty.className = 'ffcb-empty';
        const title = document.createElement('b');title.textContent = this.t('empty_title');
        const copy = document.createElement('span');copy.textContent = this.t('empty_slot');
        empty.append(title,copy);slots.append(empty);
      }
      for (const item of items) {
        const slot = document.createElement('li');slot.className = 'ffcb-slot is-filled';
        const image = document.createElement('img');image.src=item.image;image.alt='';image.width=37;image.height=50;
        const copy = document.createElement('div');copy.className='ffcb-slot__copy';
        const title = document.createElement('b');title.textContent=item.title;
        const pack = document.createElement('small');pack.textContent=item.pack;
        const price = document.createElement('span');price.textContent=this.format(item.price*item.quantity);
        copy.append(title,pack,price);
        const action = (name,label,text) => {
          const button=document.createElement('button');button.type='button';button.dataset[name]='';button.dataset.variant=item.id;button.dataset.action=name;button.textContent=text;button.setAttribute('aria-label',this.t(label,{product:item.title+' — '+item.pack}));button.disabled=this.busy || this.locked;return button;
        };
        const remove=action('remove','remove_all','×');remove.className='ffcb-slot__remove';
        const controls=document.createElement('div');controls.className='ffcb-slot__quantity';
        const decrease=action('decrease','remove_one','−');
        const quantity=document.createElement('span');quantity.textContent=this.trayLabel(item.quantity);
        const increase=action('increase','add_one','+');increase.disabled ||= !item.available || item.quantity>=item.max;
        controls.append(decrease,quantity,increase);
        slot.append(image,copy,remove,controls);slots.append(slot);
      }
      if (focused?.id) [...slots.querySelectorAll('button')].find(button => button.dataset.variant===focused.id && button.dataset.action===focused.action)?.focus({preventScroll:true});
    }
    render() {
      const {items,count,total} = this.selection();
      this.renderCards();
      this.renderSummary(items);
      this.querySelector('[data-count]').textContent=this.trayLabel(count);
      this.querySelector('[data-mobile-count]').textContent=this.trayLabel(count);
      this.querySelector('[data-mobile-total]').textContent=this.format(total);
      this.querySelector('[data-hint]').textContent=this.t(count ? 'ready' : 'choose_first');
      this.querySelector('[data-clear]').hidden=count===0;
      this.querySelector('[data-clear]').disabled=this.busy || this.locked;
      this.querySelector('[data-total]').textContent=this.format(total);
      const cans=items.filter(item=>item.unit==='cans').reduce((sum,item)=>sum+item.units*item.quantity,0);
      const bottles=items.filter(item=>item.unit==='bottles').reduce((sum,item)=>sum+item.units*item.quantity,0);
      const units=[];
      if(cans)units.push(this.t('cans_count',{count:cans}));
      if(bottles)units.push(this.t('bottles_count',{count:bottles}));
      this.querySelector('[data-total-units]').textContent=count ? this.trayLabel(count)+(units.length ? ' · '+units.join(' + ') : '') : this.t('empty_units');
      const submit=this.querySelector('[data-submit]');
      submit.disabled=count===0 || this.busy || this.locked;
      submit.textContent=this.busy ? this.t('adding') : this.t(count ? 'submit' : 'choose_first',{price:this.format(total)});
      this.renderCount();
      this.dispatchEvent(new CustomEvent('ff-case:change',{bubbles:true,detail:{version:2,currency:this.dataset.currency,items:items.map(({id,quantity,price})=>({id,quantity,price})),trayCount:count,subtotal:total}}));
    }
    save() {
      try {
        sessionStorage.setItem('ff-case-builder-v2',JSON.stringify({version:2,currency:this.dataset.currency,items:[...this.quantities].map(([id,quantity])=>({id,quantity}))}));
        sessionStorage.removeItem('ff-case-builder-v1');
      } catch {}
    }
    restore() {
      try {
        const saved=JSON.parse(sessionStorage.getItem('ff-case-builder-v2') || sessionStorage.getItem('ff-case-builder-v1'));
        if(!saved || saved.currency!==this.dataset.currency)return;
        const entries=Array.isArray(saved.items) ? saved.items : Array.isArray(saved.selected) ? saved.selected.map(id=>({id,quantity:1})) : [];
        let changed=false;
        for(const entry of entries) {
          const item=this.item(entry.id);
          if(!item?.available || !Number.isSafeInteger(entry.quantity) || entry.quantity<=0){changed=true;continue;}
          const requested=(this.quantities.get(item.id)||0)+entry.quantity;
          const quantity=Math.min(requested,item.max);
          if(quantity>0)this.quantities.set(item.id,quantity);
          if(quantity!==requested)changed=true;
        }
        this.save();
        if(changed)this.say(this.t('restored_changed'));
      } catch {}
    }
    async submit() {
      if(this.busy || this.locked || this.quantities.size===0)return;
      this.busy=true;this.say('');this.render();
      const group='ffcb-'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,9);
      let posted=false;
      try {
        const {items,count}=this.selection();
        const urls=[...new Set(items.map(item=>item.url))];
        const fresh=await Promise.all(urls.map(async url=>{const response=await fetch(url.split('?')[0]+'.js',{headers:{Accept:'application/json'},signal:AbortSignal.timeout(15000)});if(!response.ok)throw new Error(this.t('check_failed'));return response.json();}));
        const variants=new Map(fresh.flatMap(product=>product.variants).map(variant=>[String(variant.id),variant]));
        let changed=false;
        for(const item of items) {
          const variant=variants.get(item.id);
          const entry=this.variants.get(item.id);
          if(!variant || !variant.available){entry.option.dataset.available='false';entry.option.disabled=true;this.quantities.delete(item.id);changed=true;continue;}
          if(Number(variant.price)!==item.price){entry.option.dataset.price=variant.price;changed=true;}
        }
        if(changed){this.say(this.t('changed'));this.save();return;}
        const payload={items:items.map(({id,quantity})=>({id,quantity,properties:{'_ff_case_id':group,'_ff_case_size':String(count),'Case':this.t('case_property')}}))};
        posted=true;
        const response=await fetch(this.dataset.addUrl+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload),signal:AbortSignal.timeout(20000)});
        const result=await response.json();
        if(!response.ok)throw new Error(typeof result.description==='string'?result.description:this.t('add_failed'));
        try{sessionStorage.removeItem('ff-case-builder-v1');sessionStorage.removeItem('ff-case-builder-v2');}catch{}
        this.locked=true;this.say(this.t('added'));
        window.location.assign(this.dataset.cartUrl);
      } catch(error) {
        let uncertain=posted;
        if(posted) {
          try {
            const response=await fetch(this.dataset.cartJson,{headers:{Accept:'application/json'},signal:AbortSignal.timeout(10000)});
            if(response.ok){const cart=await response.json();uncertain=cart.items.some(item=>item.properties?._ff_case_id===group);}
          }catch{}
        }
        if(uncertain){this.locked=true;this.querySelector('[data-review]').hidden=false;this.say(this.t('review_error'));}
        else this.say(error.message || this.t('add_failed'));
      } finally {this.busy=false;this.render();}
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-home-bundles"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const opener = event.target.closest('[data-ffbc-open]');
  if (opener) {
    const dialog = document.getElementById(opener.dataset.ffbcOpen);
    if (dialog && !dialog.open) {
      dialog.showModal();
      const previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      dialog.addEventListener('close', function() {
        document.body.style.overflow = previousOverflow;
        opener.focus();
      }, { once: true });
    }
    return;
  }
  const closer = event.target.closest('[data-ffbc-close]');
  if (closer) closer.closest('dialog').close();
  if (event.target.matches('.ffbc-dialog')) {
    const rect = event.target.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-shop-hub"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('ff-shop-hub')) return;
  customElements.define('ff-shop-hub', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const copy = JSON.parse(this.querySelector('[data-hub-copy]').textContent);
      const cards = Array.from(this.querySelectorAll('[data-drink-range]'));
      const navLinks = Array.from(this.querySelectorAll('.ffhub__nav [data-range-link]'));
      const title = this.querySelector('[data-range-heading]');
      const description = this.querySelector('[data-range-description]');
      const counts = this.querySelector('[data-result-count]');
      const bundlePanel = this.querySelector('[data-bundle-panel]');
      const drinkPanel = this.querySelector('[data-drink-panel]');
      const valid = ['all', 'sodas', 'mixers', 'water', 'bundles'];
      const apply = (range, updateUrl) => {
        if (!valid.includes(range)) range = this.dataset.initial;
        const isBundles = range === 'bundles';
        bundlePanel.hidden = !isBundles;
        drinkPanel.hidden = isBundles;
        let count = 0;
        cards.forEach(card => {
          card.hidden = range !== 'all' && card.dataset.drinkRange !== range;
          if (!card.hidden) count++;
        });
        navLinks.forEach(link => {
          if (link.dataset.rangeLink === range) link.setAttribute('aria-current', 'page');
          else link.removeAttribute('aria-current');
        });
        title.textContent = copy.headings[range];
        description.textContent = copy.descriptions[range];
        counts.textContent = isBundles ? this.dataset.bundleCount : this.dataset.countLabel.replace('[count]', count);
        this.querySelector('[data-empty]').hidden = count > 0 || isBundles;
        if (updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('range', range);
          url.searchParams.delete('page');
          history.pushState(null, '', url);
        }
      };
      const restore = () => apply(new URL(window.location.href).searchParams.get('range') || this.dataset.initial, false);
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-range-link]');
        if (!link || !this.contains(link) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        apply(link.dataset.rangeLink, true);
      });
      this.addEventListener('change', event => {
        const select = event.target.closest('[data-hub-variant]');
        if (!select) return;
        const card = select.closest('[data-drink-range]');
        const choice = select.selectedOptions[0];
        card.querySelector('[data-hub-price]').textContent = choice.dataset.price;
        card.querySelector('[data-hub-unit]').textContent = choice.dataset.unit;
        const button = card.querySelector('[data-hub-add]');
        button.disabled = choice.dataset.available !== 'true';
        button.textContent = button.disabled ? button.dataset.soldOut : button.dataset.addLabel;
        card.querySelectorAll('[data-hub-product-link]').forEach(link => {
          const url = new URL(link.href);
          url.searchParams.set('variant', choice.value);
          link.href = url.href;
        });
        const image = card.querySelector('img');
        if (image && choice.dataset.image) {
          image.removeAttribute('srcset');
          image.src = choice.dataset.image;
        }
      });
      this.restore = restore;
      window.addEventListener('popstate', restore);
      restore();
    }
    disconnectedCallback() {
      if (this.restore) window.removeEventListener('popstate', this.restore);
      delete this.dataset.ready;
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
